import React, { useEffect, useState } from "react"

import { Row, Col, Card, CardBody } from "reactstrap"

import { connect } from "react-redux";
import { useDispatch } from 'react-redux';

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { useSelector } from "react-redux";
import Loader from "components/Loader/Loader";
import { useNavigate } from "react-router-dom";


const CreateStudent = (props) => {
    document.title = "Student Management | Create  Students";

    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // let questionPapers = useSelector(state => state.questionPapersReducer.questionPapers)


    const breadcrumbItems = [
        { title: "Students", link: "#" },
        { title: "Create Students", link: "#" },
    ]
    useEffect(() => {           /* For closing the sidebar if opened */
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])



    useEffect(() => {
        props.setBreadcrumbItems('Create Students', breadcrumbItems)
    })

    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row>

                <Col>
                    <Card>
                        {/* <CardBody className="col-xl-6 col-lg-10 col-md-10 col-sm-12 col-xs-12"> */}
                        <CardBody className="" style={{ height: "70vh" }}>
                            <div className="d-flex justify-content-around flex-wrap align-items-center h-100">
                                <div className="d-flex justify-content-center align-items-center p-2" style={{ border: "2px dashed red", height: "5rem", borderRadius: "10px", cursor: "pointer" }} onClick={() => navigate("/create-single-student")}><h2>Create Single Student</h2></div>
                                <div className="d-flex justify-content-center align-items-center p-2" style={{ border: "2px dashed blue", height: "5rem", borderRadius: "10px", cursor: "pointer" }} onClick={() => navigate("/create-multiple-student")}><h2>Create Multiple Student</h2></div>
                            </div>


                        </CardBody>
                    </Card>
                </Col>
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateStudent);